import styled from 'styled-components';
import { Col } from 'reactstrap';
import colors from '../../includes/colors'

export const BirdseedBox = styled(Col)`
  font-size: 0.675rem;
  line-height: 1.125rem;
`;

export const BirdseedContainer = styled.div`
  background-color: ${colors.darkBlue}
`;
